// @owners { team: patients }
import { useNavigation } from '@alto/navigation';
import { Platform } from 'react-native';
import { getEditShipmentID } from '~shared/features/checkout/selectors/getCheckout';
import { useSelectorShared } from '~shared/store';

export const useShipmentID = () => {
  const { getParam } = useNavigation();
  const editOrderShipmentID = useSelectorShared(getEditShipmentID);

  // get shipment ID from the current route or from the cart state `editOrderShipmentID`
  const shipmentID =
    Platform.OS === 'web'
      ? // @ts-expect-error this is not a good practice since we can't verify if param present for route
        Number(getParam('shipmentID'))
      : // @ts-expect-error this is not a good practice since we can't verify if params present for route
        Number(getParam?.('shipmentID', editOrderShipmentID));
  return { shipmentID };
};
